import React, { useEffect, useState } from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import styled from "styled-components";
import { useStaticQuery, graphql } from "gatsby";
import Nav from "@components/Nav";
import References from "@components/References";

import useAppContext from "@hooks/useAppContext";
import Header from "@components/Header/Header";
import ExitModal from "@components/ExitModal";
import Footer from "@components/Footer";

import IsiComponent from "@components/Isi";
import EfficacyNavigation from "@components/EfficacyNavigation";
import ResourcesSidebar from "@components/ResourceSidebar/ResourcesSidebar";


// Styled body component to handle background color
const StyledBody = styled.div`
	background: ${props => props.$backgroundColor || 'transparent'};
`;



const Layout = ({ children, backgroundColor, isi, references, isEfficacyPage, isResourcesPage, resources, header }) => {
	const { headerRef, isiRef } = useAppContext();
	const [whiteHeader, setWhiteHeader] = useState(false);


	useEffect(() => {
		header?.includes('White') && setWhiteHeader(true);
	}, [header]);

	const data = useStaticQuery(graphql`
	query efficacySideNav {
		contentfulContainer(entryTitle: {eq: "Exparel HCP | Efficacy | SideBar"}) {
			...ContentfulContainerFragment
		}
	}
	`
	)


	return (
		<>
			{/* Update reCaptchaKey if you are using a form. Otherwise remove GoogleReCaptchaProvider */}
			<GoogleReCaptchaProvider
				reCaptchaKey={process.env.GOOGLE_RECAPTCHA_SITE_KEY}
			>

				<StyledBody $backgroundColor={backgroundColor} className={`mobileTabletMax:overflow-x-hidden`}>
					<Header innerRef={headerRef} nav={Nav} whiteHeader={whiteHeader} />
					<main id="main-content" className="relative">
						{(isEfficacyPage || isResourcesPage) && (
							<div className="">
								<div className={`lg:z-[2] relative`}>
									{children[0]}
								</div>

								<div className="flex flex-col xl:flex-row justify-center mx-auto xl:bg-soft_blue rounded-bottom_48 xl:items-stretch items-center  z-[1] relative">
									<div className="flex-col xl:max-w-[241px] xl:pr-[40px] xl:bg-soft_blue w-full xl:mt-[-100px] xl:pt-[150px] xl:rounded-bl-[48px]  flex relative">
										{isEfficacyPage && (
											<EfficacyNavigation sections={data.contentfulContainer.items} />
										)}
										{isResourcesPage && (
											<ResourcesSidebar/>
										)}
									</div>
									<div className="flex flex-col w-full bg-white xl:mt-[-100px] xl:pt-[100px] xl:rounded-br-[48px] xl:rounded-bl-none xl:rounded-bottom_48 rounded-all_48">
										{children.slice(1, (children.length - 1))}
									</div>
								</div>
								{children[children.length - 1]}
							</div>
						)}
						{!isEfficacyPage && !isResourcesPage && (
							<>
								{children}
							</>
						)}

						<IsiComponent isiRef={isiRef} isi={isi} className={`mt-[-100px] relative`} />
						<div className={`footer-references flex flex-col ${references ? 'pt-[100px]  mt-[-100px]  bg-gradient-references rounded-top_48' : ''}`}>
							{references && <References references={references} />}
							<Footer />
						</div>
					</main>
					<ExitModal />
				</StyledBody>
			</GoogleReCaptchaProvider>
		</>
	);
};

export default Layout;
